<template>
  <div class="web-box-all">
    <ext-header ref="ExtHomeHeader" select_menu="2"></ext-header>

    <div class="web-home-main">
      <div class="web-goods-list-class">
        <div class="web-goods-list-class-list">
          <h2>商品分类</h2>
          <ul>
            <li v-for="(vo,index) in class_list" :key="index">
              <a @click="go_goods_class(vo.id)" :class="[select_id==vo.id ? 'select' : '']">{{vo.title}}</a>
            </li>
          </ul>
        </div>
      </div>

      <div class="web-goods-list-top">
        <div class="web-goods-list-top-left">
          <p>
            {{select_class}}
          </p>
        </div>
        <div class="web-goods-list-top-right">
          <b>共{{list_count}}件商品</b>
          <b style="display:none">1 / {{list_data.length}}件</b>
          <p style="display:none"><img src="@/assets/icon/left_1.png"/></p>
          <p style="display:none"><img src="@/assets/icon/right_1.png"/></p>
        </div>
      </div>

    </div>

    <div class="web-goods-main">

      <ext-loading v-if="list_data.length==0" style="width:100%;" :title="page_msg"></ext-loading>

      <div class="web-home-goods">

        <div v-for="(vo,index) in list_data" :key="index" :class="[vo.select==1 ? 'web-home-goods-list active' : 'web-home-goods-list']" v-on:mouseover="changeActive(index,'list_data')" v-on:mouseout="removeActive(index,'list_data')">
          <a @click="get_goods_show(vo.goods_no)">
            <div :class="[vo.select==1 ? 'web-home-goods-list-data active' : 'web-home-goods-list-data']">
              <img src="@/assets/goods_load.png" v-real-img="web_url+vo.goods_image">
              <p>
                <i>¥</i><b>{{vo.goods_money}}</b>
              </p>
              <h2>{{vo.goods_name}}</h2>
              <h3>{{vo.goods_no}}</h3>
            </div>
          </a>
          <h4>
            <b class="del" @click="goods_del(index)">-</b>
            <b class="num">
              <input type="number" v-model.number="vo.qty" oninput="if(value.length>3)value=value.slice(0,3)" />
            </b>
            <b class="add" @click="goods_add(index)">+</b>
            <b class="cart" @click="add_cart(index,vo.goods_no)">
              <img src="@/assets/icon/cart01.png"/>
            </b>
            <b class="collect" @click="set_collect(index,vo.goods_no)">
              <img v-if="vo.collect_state==1" src="@/assets/icon/love01.png"/>
              <img v-else src="@/assets/icon/love02.png"/>
            </b>
          </h4>
        </div>

      </div>

      <div class="web-order-list-page" v-if="select_id=='all'">
          <b-pagination
            v-model="currentPage"
            :total-rows="list_count"
            :per-page="perPage"
            @change="load_page"
            first-number
            last-number
          >
          <template #prev-text><span class="lemon-page">上一页</span></template>
          <template #next-text><span class="lemon-page">下一页</span></template>
          <template #page="{ page, active }">
            <b class="lemon-page-now" v-if="active">{{ page }}</b>
            <i class="lemon-page-line" v-else>{{ page }}</i>
          </template>
          </b-pagination>
        </div>

    </div>

    <div class="web-home-line"></div>

    <ext-footer ref="ExtHomeFooter"></ext-footer>

    <ext-toast :style="toast_state" :toast_text="toast_text"></ext-toast>

  </div>
</template>
<script>
import ExtHomeHeader from '@/components/header/home'
import ExtHomeFooter from '@/components/footer/home'
import ExtLoading from '@/components/loading/index'
import {getUserId, ajax, Encrypt, Decrypt, webUrl} from '@/utils/extend'
import Toast from '@/components/toast/index'

export default {
  name: 'goods_list',
  components: {
    'ext-header': ExtHomeHeader,
    'ext-footer': ExtHomeFooter,
    'ext-loading': ExtLoading,
    'ext-toast': Toast
  },
  data () {
    return {
      title: '商品列表',
      web_url: webUrl(),
      select_id: 0,
      select_class: '',
      class_list: [],
      order_type: 1,
      sales_type: 1,
      fee_type: 1,
      list_data: [],
      toast_state: 'display:none',
      toast_text: '',
      list_count: 0,
      perPage: 20,
      currentPage: 1,
      page_msg: '加载中'
    }
  },
  mounted () {
    var params = this.$route.query
    if (Decrypt(params.v)) {
      if (params.v) {
        this.select_id = Decrypt(params.v)
      }

      this.load_goods_class()
      this.load_goods_data()
    } else {
      this.select_id = 'all'
      this.load_goods_class()
      this.load_goods_data()
    }
  },
  methods: {
    toast (msg) {
      var that = this
      that.toast_state = 'display:block'
      that.toast_text = msg
      setTimeout(function () {
        that.toast_text = ''
        that.toast_state = 'display:none'
      }, 1000)
    },
    get_goods_show (goodsNo) {
      // let routeData = this.$router.resolve({path: '/goods/goods_show', query: {v: Encrypt(goodsNo)}})
      // window.open(routeData.href, '_blank')
      this.$router.push({path: '/goods/goods_show', query: {v: Encrypt(goodsNo)}})
    },
    get_order_type (id) {
      this.order_type = id
      if (id === 2) {
        var salesType = this.sales_type
        if (salesType === 1) {
          this.sales_type = 2
        } else {
          this.sales_type = 1
        }
      } else if (id === 3) {
        var feeType = this.fee_type
        if (feeType === 1) {
          this.fee_type = 2
        } else {
          this.fee_type = 1
        }
      } else {
        this.sales_type = 1
        this.fee_type = 1
      }

      this.load_goods_data()
    },
    goods_add (index) {
      var listdata = this.list_data
      var qty = listdata[index].qty ? listdata[index].qty : 1
      if (qty < 999) {
        qty = parseInt(qty) + 1
      } else {
        qty = 999
      }
      this.$set(this.list_data[index], 'qty', qty)
    },
    goods_del (index) {
      var listdata = this.list_data
      var qty = listdata[index].qty ? listdata[index].qty : 1
      if (qty > 1) {
        qty = parseInt(qty) - 1
      } else {
        qty = 1
      }
      this.$set(this.list_data[index], 'qty', qty)
    },
    set_collect (index, goodsNo) {
      var listdata = this.list_data
      var state = listdata[index].collect_state ? listdata[index].collect_state : 0
      var goodsId = listdata[index].id
      var that = this
      if (state === '1') {
        this.$set(this.list_data[index], 'collect_state', '0')
        ajax({
          url: '/store/goods/goods_collect',
          method: 'post',
          data: {
            uid: getUserId(),
            goods_id: goodsId,
            collect_type: 2
          }
        }, function (ret) {
          that.$refs.ExtHomeFooter.get_cart_count()
        })
      } else {
        this.$set(this.list_data[index], 'collect_state', '1')
        ajax({
          url: '/store/goods/goods_collect',
          method: 'post',
          data: {
            uid: getUserId(),
            goods_id: goodsId,
            collect_type: 1
          }
        }, function (ret) {
          that.$refs.ExtHomeFooter.get_cart_count()
        })
      }
    },
    add_cart (index, goodsNo) {
      var that = this
      var listdata = this.list_data
      var qty = listdata[index].qty ? listdata[index].qty : 1

      ajax({
        url: '/store/order/add_cart',
        method: 'post',
        data: {
          uid: getUserId(),
          type_id: 1,
          type_add: 'add',
          goods_no: goodsNo,
          qty: qty
        }
      }, function (ret) {
        if (ret && ret.code === 'success') {
          that.toast(ret.msg)
          that.$refs.ExtHomeHeader.load_cart_list()
          that.$refs.ExtHomeFooter.get_cart_count()
        } else {
          that.toast(ret.msg)
        }
      })
    },
    go_goods_class (id) {
      var selectId = this.select_id
      if (selectId !== id) {
        this.$router.push({path: '/goods/goods_list', query: {v: Encrypt(id)}})
      }
    },
    changeActive (index, list) {
      this.$set(this['' + list][index], 'select', '1')
    },
    removeActive (index, list) {
      this.$set(this['' + list][index], 'select', '0')
    },
    load_goods_class () {
      var that = this
      ajax({
        url: '/store/goods/class_list_json',
        method: 'post',
        data: {
          uid: getUserId(),
          type: 'web'
        }
      }, function (ret) {
        if (ret && ret.code === 'success') {
          that.class_list = ret.data

          var classList = ret.data
          for (var i = 0; i < classList.length; i++) {
            var val = classList[i]
            if (val['id'] === that.select_id) {
              that.select_class = val['title']
            }
          }
        } else {
          that.class_list = []
        }
      })
    },
    load_page (page) {
      this.currentPage = page
      this.load_goods_data()
    },
    load_goods_data () {
      var that = this
      var classId = this.select_id
      var orderType = this.order_type
      var salesType = this.sales_type
      var feeType = this.fee_type
      var page = that.currentPage
      that.list_data = []
      that.$refs.ExtHomeFooter.go_top()
      ajax({
        url: '/store/goods/goods_list_json',
        method: 'post',
        data: {
          uid: getUserId(),
          class_id: classId,
          order_type: orderType,
          sales_type: salesType,
          fee_type: feeType,
          page: page
        }
      }, function (ret) {
        if (ret && ret.code === 'success') {
          var list = ret.data.list_data

          var LlistArray = []
          list.forEach(function (vo) {
            LlistArray.push({
              'id': vo.id,
              'goods_no': vo.goods_no,
              'sectionId': vo.sectionId,
              'goods_name': vo.goods_name,
              'goods_image': vo.goods_image,
              'goods_remark': vo.goods_remark,
              'goods_money': vo.goods_money,
              'integral': vo.integral,
              'goods_qty': vo.goods_qty,
              'qty': 1,
              'collect_state': vo.collect_state
            })
          })
          that.list_data = LlistArray
          that.list_count = ret.data.list_count
        } else {
          that.page_msg = ret.msg
          that.list_data = []
          that.list_count = 0
        }
      })
    }
  }
}
</script>
<style scoped>
header,section,footer,div,ul,ol,li,img,a,span,em,del,legend,center,strong,var,fieldset,form,label,dl,dt,dd,cite,input,hr,time,mark,code,figcaption,figure,textarea,h1,h2,h3,h4,h5,h6,p{
    display:-moz-box;
    display: box;
    display: -webkit-box;
    font-family: "Noto Sans SC";
    display: inline-flex;
}

a { text-decoration:none; }
input { box-sizing:border-box;outline:none;}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {-webkit-appearance: none;}
input[type='number'] {-moz-appearance: textfield;}

.web-box-all { width:100%; height:auto; flex-wrap:wrap; align-content:flex-start;}
.web-home-main { width:1200px; height:auto; margin:0px auto; flex-wrap:wrap; align-content:flex-start;}
.web-home-line { width:100%; height:70px; }

/* 商品列表 */
.web-goods-main { width:1225px; height:auto; margin:0px auto; flex-wrap:wrap; align-content:flex-start;}
.web-home-goods { width:100%; height:auto; margin-top:10px; display: flex; flex-flow:row; align-content:flex-start; flex-wrap:wrap;}
  .web-home-goods-list { width:245px; height:410px; position: relative; margin:5px 0px; padding:10px; border:1px solid #ffffff;}
  .web-home-goods-list.active { border:1px solid #d81e06;}
  .web-home-goods-list-data { width:223px; height:390px; cursor: pointer; border:1px solid #e7e7e7; flex-wrap:wrap; align-content:flex-start;}
  .web-home-goods-list-data.active { border:1px solid #ffffff;}
  .web-home-goods-list-data img { width:100%; height:220px; padding:10px 10px 0px 10px;}
  .web-home-goods-list-data h2 { width:223px; height:40px; word-break:break-all; display:-webkit-box;
  text-overflow:ellipsis;
  overflow:hidden;
  -webkit-line-clamp: 2;
  -webkit-box-orient:vertical; line-height:20px; margin:5px 0px; font-size:14px; color:#333333; padding:0px 10px;}
  .web-home-goods-list-data h3 { width:223px; height:20px; line-height:20px; margin:0px; font-size:12px; color:#333333; padding:0px 10px;}
  .web-home-goods-list-data p { width:223px; height:40px; padding:0px 10px; margin:0px; flex-flow:row; align-content:flex-start;}
  .web-home-goods-list-data p i { font-size:12px; margin-right:5px; margin-top:10px; font-style:normal; color:#d81e06;}
  .web-home-goods-list-data p b { font-size:22px; color:#d81e06;}
  .web-home-goods-list h4 { width:223px; height:40px; -webkit-user-select: none; -moz-user-select: none; -ms-user-select: none; user-select: none; position: absolute; left:15px; bottom: 10px; z-index: 99; margin:0px; padding:0px 10px; flex-flow:row; align-content:flex-start;}
  .web-home-goods-list h4 b { font-size:14px; line-height:30px; float:left; font-weight: normal;}
  .web-home-goods-list h4 b.del { width:30px; height:30px; cursor: pointer; line-height:25px; text-align: center; color:#666666; font-size:20px; border:1px solid #e7e7e7;}
  .web-home-goods-list h4 b.num { width:44px; height:30px; overflow: hidden; border-top:1px solid #e7e7e7; border-bottom:1px solid #e7e7e7;}
  .web-home-goods-list h4 b.num input { width:44px; height:20px; margin-top:5px; text-align: center; line-height:20px; font-size:12px; color:#333333; min-height:20px; border:0px;}
  .web-home-goods-list h4 b.add { width:30px; height:30px; cursor: pointer; line-height:25px; text-align: center; color:#666666; font-size:20px; border:1px solid #e7e7e7;}
  .web-home-goods-list h4 b.cart { width:30px; height:30px; cursor: pointer; margin-left:22px; text-align: center; border-radius: 3px;  line-height:30px; background: #fff; font-size:13px; color:#ffffff;}
  .web-home-goods-list h4 b.cart img { width:26px; height:26px; }
  .web-home-goods-list h4 b.collect { width:30px; height:30px; cursor: pointer; margin-left:8px; text-align: center; border-radius: 3px; line-height:30px; background: #fff; font-size:13px; color:#ffffff;}
  .web-home-goods-list h4 b.collect img { width:26px; height:26px; }

.web-goods-list-class { width:100%; height:auto; flex-wrap:wrap; align-content:flex-start; margin-top:13px; border:1px solid #dfdfdf;}
  .web-goods-list-class-list { width:100%; height:auto; display: flex; flex-wrap:wrap; align-content:flex-start;}
  .web-goods-list-class-list h2 { width:140px; height:40px; padding-left:20px; line-height:40px; font-size:14px; color:#333333;}
  .web-goods-list-class-list ul { width:100px; height:auto; list-style:none; margin:0px; padding:0px; flex:1; flex-wrap:wrap; align-content:flex-start;}
  .web-goods-list-class-list ul li { min-width:100px; height: 40px; line-height:40px; text-align: center; font-size:14px; color:#333333;}
  .web-goods-list-class-list ul li a { color:#333333; width:auto; cursor: pointer; height: 40px; padding:0px 5px;}
  .web-goods-list-class-list ul li a:hover { color:#d81e06; font-weight: bold;}
  .web-goods-list-class-list ul li a.select { color:#d81e06; font-weight: bold;}

  .web-goods-list-top { width: 100%; height:48px; overflow: hidden; display:flex; margin-top:20px; background: #f5f5f5; flex-flow:row; align-content:flex-start;}
  .web-goods-list-top-left { width:100px; height:48px;}
  .web-goods-list-top-left p { width:100px; height:48px; position: relative; border:1px solid #dfdfdf;  line-height:48px;font-size:14px; color:#333333; font-weight: bold; cursor: pointer; text-align: center; justify-content:center; color:#333333;}
  .web-goods-list-top-left p.select { background: #ffffff; border:1px solid #d81e06;  color:#d81e06;}
  .web-goods-list-top-left p:hover { color:#d81e06;}
  .web-goods-list-top-right { width:100px; height:48px; flex: 1; border-top:1px solid #dfdfdf; border-right:1px solid #dfdfdf; border-bottom:1px solid #dfdfdf; flex-flow:row; justify-content:flex-end;}
  .web-goods-list-top-right b { width:auto; height:48px; font-size:12px; margin-right:10px; font-weight: normal; line-height:48px;}
  .web-goods-list-top-right p { width:48px; height:48px; cursor: pointer; position: relative; flex-flow:row; border-left:1px solid #dfdfdf; align-content:flex-start;}
  .web-goods-list-top-right p img { width:20px; height:20px; position: absolute; top:14px; left:12px;}

</style>
<style>
  .text-truncate { text-overflow:initial;}
  .lemon-page { color:#333333; font-size:14px; height:24px; line-height:24px;}
  .lemon-page-now { background: #d81e06 !important; color:#ffffff !important; width:24px; height:24px;}
  .lemon-page-line { color:#333333; font-style: normal;}
  .page-item.active .page-link { border:1px solid #d81e06;background: #d81e06 !important; color:#ffffff !important;}
  .btn-sm, .btn-group-sm > .btn { width:auto !important;}
  #select_type button { width:70px !important; text-align: left !important;}
</style>



// WEBPACK FOOTER //
// src/pages/goods/goods_list.vue